@if (loaderService.isLoading | async) {
  <div class="rcg-loader-container">
    <rcg-loader [mode]="brand"></rcg-loader>
  </div>
}
<ng-content></ng-content>
